var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex flex-col h-full pb-16" },
    [
      _vm.conversationToShowExists
        ? [
            _vm.canLeave
              ? _c("InboxWindowHead", {
                  attrs: {
                    conversation: _vm.conversation,
                    isGroupConversation: _vm.isGroupConversation,
                    currentUserId: _vm.currentUser.id,
                    noParticipants: _vm.noParticipants,
                    onlyParticipant: _vm.onlyParticipant,
                    participants: _vm.participants,
                  },
                  on: { conversationDeleted: _vm.handleConversationDeleted },
                })
              : _vm._e(),
            _c("InboxWindowMessages", {
              attrs: {
                messages: _vm.messages,
                conversationId: _vm.conversation.id,
                currentUserId: _vm.currentUser.id,
                isGroupConversation: _vm.isGroupConversation,
                noParticipants: _vm.noParticipants,
                uploadingAttachmentId: _vm.uploadingAttachmentId,
              },
            }),
            _c("InboxWindowTextarea", {
              attrs: {
                noParticipants: _vm.noParticipants,
                predefinedMessage: _vm.predefinedMessage,
              },
              on: {
                send: (e) => _vm.$emit("send", e),
                newMessage: _vm.newMessageAdded,
              },
            }),
          ]
        : _c("InboxWindowEmpty"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }